import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Tool from "./Tool";
import App from "./App";

export default function Root() {
  return (
    <Router>
      <div>
        {/* <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
          </ul>
        </nav> */}

        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}

        <Switch>
          <Route exact path="/" component={App} />
          <Route path="/about" component={About} />
          <Route path="/tool" component={Tool} />
        </Switch>
      </div>
    </Router>
  );
}

function About() {
  return <h2>About</h2>;
}
function Home() {
  return <h2>Home</h2>;
}
